import { assert, assertDefined } from "@configura/web-utilities";
import { _CfgProductInternal } from "../CfgProduct.js";
import { _CfgFeatureInternal } from "../productConfiguration/CfgFeature.js";
import { _CfgOptionInternal } from "../productConfiguration/CfgOption.js";
import { _CfgProductConfigurationInternal } from "../productConfiguration/CfgProductConfiguration.js";
export class SyncGroupsPathHelper {
    static getPath(item) {
        if (item instanceof _CfgProductInternal) {
            const parent = item.parent;
            const refKey = item.refKey;
            if (parent === undefined || refKey === undefined) {
                return [];
            }
            return [...this.getPath(parent), "p", refKey];
        }
        if (item instanceof _CfgProductConfigurationInternal) {
            return [...this.getPath(item.parentProduct), "c"];
        }
        if (item instanceof _CfgFeatureInternal) {
            return [...this.getPath(item.parent), item.code];
        }
        if (item instanceof _CfgOptionInternal) {
            return [...this.getPath(item.parent), item.code];
        }
        throw new Error("This should not happen");
    }
    static getFromPath(path, root) {
        path = path.slice();
        let item = root;
        while (path.length > 0) {
            const segment = path.shift();
            if (item instanceof _CfgProductInternal) {
                switch (segment) {
                    case "p": {
                        const refKey = path.shift();
                        const additional = item.additionalProducts.find((p) => p.refKey === refKey);
                        assertDefined(additional, `Additional product not found "p, ${refKey !== null && refKey !== void 0 ? refKey : ""}, ${path.join(", ")}"`);
                        item = additional._internal;
                        break;
                    }
                    case "c":
                        assert(item instanceof _CfgProductInternal, "Was not product");
                        item = item.configuration._internal;
                        break;
                    default:
                        throw new Error(`Unexpected path segment "${segment !== null && segment !== void 0 ? segment : ""}"`);
                }
            }
            else if (item instanceof _CfgProductConfigurationInternal) {
                const feature = item.features.find((f) => f.code === segment);
                assertDefined(feature, `Feature not found "${segment !== null && segment !== void 0 ? segment : ""}", ${path.join(", ")}`);
                item = feature._internal;
            }
            else if (item instanceof _CfgFeatureInternal) {
                const option = item.options.find((o) => o.code === segment);
                assertDefined(option, `Option not found "${segment !== null && segment !== void 0 ? segment : ""}", ${path.join(", ")}`);
                item = option._internal;
            }
            else if (item instanceof _CfgOptionInternal) {
                const feature = item.features.find((o) => o.code === segment);
                assertDefined(feature, `Feature not found "${segment !== null && segment !== void 0 ? segment : ""}", ${path.join(", ")}`);
                item = feature._internal;
            }
            else {
                throw new Error("This should not happen (unexpected type)");
            }
        }
        return item;
    }
    static getProductFromPath(path, item) {
        const p = this.getFromPath(path, item);
        assert(p instanceof _CfgProductInternal, `Path did not lead to a Product`);
        return p;
    }
    static getProductConfigurationFromPath(path, item) {
        const c = this.getFromPath(path, item);
        assert(c instanceof _CfgProductConfigurationInternal, `Path did not lead to a ProductConfiguration"`);
        return c;
    }
    static getFeatureFromPath(path, item) {
        const f = this.getFromPath(path, item);
        assert(f instanceof _CfgFeatureInternal, `Path did not lead to a Feature`);
        return f;
    }
    static getOptionFromPath(path, item) {
        const o = this.getFromPath(path, item);
        assert(o instanceof _CfgOptionInternal, `Path did not lead to a Option`);
        return o;
    }
}
